import { QueryClient } from '@tanstack/react-query';

import { shouldRetry } from '../utils/http-status';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
    },
    mutations: {
      retry: shouldRetry,
    },
  },
});
